<div class="row">
  <div class="col-md-12">
    <div class="mb-4" *ngFor="let activity of activities">
      <ng-container [ngSwitch]="activity.activityType">
        <ng-container *ngSwitchCase="'FileUpload'">
          <common-activity-file-upload [activity]="activity"></common-activity-file-upload>
        </ng-container>
        <ng-container *ngSwitchCase="'DataEntry'">
          <common-activity-data-entry [activity]="activity"></common-activity-data-entry>
        </ng-container>

        <ng-container *ngSwitchDefault>No component for {{ activity.activityType }}</ng-container>
      </ng-container>
    </div>
  </div>
</div>
